import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';

import { getFile } from '../../../../util/file.js';

import { getContentBlockItemsByName, getContentBlockItemValue, getContentBlockMixedItem } from '../../../Cms/CmsActions.js';

import HtmlComponent from '../../../../components/Text/HtmlComponent.js';
import CategorySeo from '../../components/view/CategorySeo.js';
import Breadcrumbs from '../../../App/components/view/Breadcrumbs.js';

import PreFooter from '../../../App/components/PreFooter.js';

import ProductShippingInformation from '../../components/view/ProductShippingInformation.js';
import withRouter from '../../../../components/Router/WithRouter.js';
import PageCover from '../../../Cms/components/view/PageCover.js';
import ProductsListWrapper from '../../components/list/ProductsListWrapper.js';
import CmsPanel from '../../../Cms/components/content/CmsPanel.js';
import StarRating from '../../../Review/components/view/StarRating.js';
import VoucherProgress from '../../../Voucher/components/view/VoucherProgress.js';
import { getUserGroup, USER_GROUP_DEFAULT } from '../../../User/UserGroupActions.js';

function CategoryViewPage({ search, page = null, userGroup = null }) {
	const currentPageIndex = parseInt(search.get('page'), 10) || 1;

	const { blocks } = page || {};
	const cover = getContentBlockItemValue(blocks, 'cover', 'path');
	const title = getContentBlockItemValue(blocks, 'title') || page.title;
	const breadcrumbs = getContentBlockItemsByName(page.blocks, 'breadcrumbs');
	const descriptions = getContentBlockItemsByName(blocks, 'description');
	const descriptionsAlt = getContentBlockItemsByName(blocks, 'descriptionAlt');
	const productsByPage = getContentBlockItemValue(blocks, 'productsByPage');
	const onlyPromotions = getContentBlockItemValue(blocks, 'onlyPromotions');
	const hideProductsTitle = getContentBlockItemValue(blocks, 'hideProductsTitle', 'value');

	const categoriesPanel = getContentBlockItemValue(blocks, 'categories');
	const promotionHighlight = getContentBlockItemValue(blocks, 'promotionHighlight') || '1 saucisson surprise offert';

	const scrollToProducts = () => {
		const el = document.getElementById('product-list');
		if(!el) return;
		const top = el.getBoundingClientRect().top + window.scrollY - 60;
		window.scrollTo({ behavior: 'smooth', top });
	};

	return (
		<Fragment>
			<div className="top">
				<CategorySeo
					page={page}
					title={title}
					description={descriptions.map(description => (getContentBlockMixedItem(description, 'text') || {}).text).join(', ')}
					cover={cover}
				/>

				<PageCover
					page={page}
					beforeTitle={(
						<Container>
							<Breadcrumbs crumbs={[...breadcrumbs, title]} />
						</Container>
					)}
				/>

				{userGroup?.identifier === USER_GROUP_DEFAULT && (
					<Container className="mt-n5 w-100 w-lg-75 m-auto bg-white rounded-top border border-2 border-danger border-bottom-0">
						<Row className="g-0">
							<Col xs="8" sm="9" md="10">
								<div className="pt-1 px-0 px-md-2">
									<VoucherProgress hideProgress ctaAnchor="#product-list" isStandalone />
								</div>
							</Col>
							<Col xs="4" sm="3" md="2">
								<div className="pt-3 pt-md-1">
									<StarRating size="sm" centered />
								</div>
							</Col>
						</Row>
					</Container>
				)}

				{currentPageIndex === 1 && descriptions && descriptions.length > 0 && (
					<div className="pt-4 px-2 pb-3 pb-lg-4 px-md-0 bg-info">
						<Container>
							{descriptions.map((description, index) => {
								const { text } = getContentBlockMixedItem(description, 'text') || {};
								const image = getContentBlockMixedItem(description, 'image') || {};
								const renderText = () => <HtmlComponent key={index} text={text} useCollapse />;
								const renderImage = () => image.path && (
									<picture className="d-none d-md-inline">
										<source srcSet={getFile(image.path, { format: 'webp' })} type="image/webp" loading="lazy" />
										<img src={getFile(image.path, { width: 600 })} alt={image.text || title} className="w-100 rounded" loading="lazy" />
									</picture>
								);
								if(!image.path) {
									return renderText();
								}
								return (
									<Row key={index} className="py-2">
										<Col xs="12" md={index % 2 === 0 ? 8 : 4}>
											{index % 2 === 0 ? renderText() : renderImage()}
										</Col>
										<Col xs="12" md={index % 2 === 0 ? 4 : 8}>
											{index % 2 === 0 ? renderImage() : renderText()}
										</Col>
									</Row>
								);
							})}
						</Container>
					</div>
				)}

				<div id="product-list">
					<ProductsListWrapper
						page={page}
						hideTitle={currentPageIndex !== 1 || hideProductsTitle || true}
						productsByPage={productsByPage}
						onlyPromotions={onlyPromotions}
					/>
				</div>
			</div>

			<ProductShippingInformation />

			<div className="bottom">
				{currentPageIndex === 1 && descriptionsAlt && descriptionsAlt.length > 0 && (
					<div className="py-4 px-2 px-md-0 bg-info">
						<Container>
							{descriptionsAlt.map((description, index) => {
								const { text } = getContentBlockMixedItem(description, 'text') || {};
								const image = getContentBlockMixedItem(description, 'image') || {};
								const renderText = () => <HtmlComponent key={index} text={text} />;
								const renderImage = () => image.path && <img src={getFile(image.path, { width: 540 })} alt={image.text || title} className="d-none d-md-inline rounded-sm w-100" loading="lazy" />;
								if(!image.path) {
									return renderText();
								}
								return (
									<Row key={index} className="py-2">
										<Col xs="12" md="6">
											{index % 2 === 0 ? renderText() : renderImage()}
										</Col>
										<Col xs="12" md="6">
											{index % 2 === 0 ? renderImage() : renderText()}
										</Col>
									</Row>
								);
							})}
						</Container>
					</div>
				)}

				{/* <ReviewSummary hideLogo /> */}

				<div className="bg-info">
					{categoriesPanel && <CmsPanel slug={categoriesPanel || 'categories'} />}
					<PreFooter />
				</div>
			</div>

		</Fragment>
	);
}

function mapStateToProps(store, props) {
	return {
		userGroup: getUserGroup(store),
	};
}

CategoryViewPage.propTypes = {
    page: PropTypes.object.isRequired,
	search: PropTypes.object.isRequired,
	userGroup: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(withRouter(CategoryViewPage, ['search']));
